import { render } from "./ImgNoFilesInLibrary.vue?vue&type=template&id=5642cf3c"
import script from "./ImgNoFilesInLibrary.vue?vue&type=script&lang=js"
export * from "./ImgNoFilesInLibrary.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__